import predicates from '../predicates'
import selectors from '../selectors'
import { PAID_TRAFFIC_SOURCE } from '../constants'

const paid = {
  rule: predicates.and(
    predicates.searchParamsIncludeOne('utm_source'),
    predicates.or(
      predicates.searchParamEqualsOne('utm_medium', 'fbads', 'cpc', 'fbads_dyn'),
      predicates.searchParamEqualsOne('utm_source', 'googlecpc', 'cpc')
    )
  ),
  extractor: traffic => {
    const trafficSource = PAID_TRAFFIC_SOURCE
    const trafficId = selectors.searchParamValue(traffic, 'utm_source')

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default paid



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/paid.js